import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  host:{'class':'sticky-footer'}
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  getYear(){
    return moment(Date.now()).format('YYYY');
  }

}



// WEBPACK FOOTER //
// ./src/app/common-components/footer/footer.component.ts